<template>
    <section class="tables new-updated-design">
        <vue-snotify></vue-snotify>
        <div class="row">
            <div class="col-xl-6 grid-margin stretch-card weather-table">
                <div class="card">
                    <div class="card-body new-card-body">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="background-image" v-if="current_weather.length !== 0">
                                    <div class="contents">
                                        <h5>{{ current_weather.city_name ? current_weather.city_name:  $t('location-name')}} {{current_weather.country_name }} {{ current_weather.local_time ? current_weather.local_time:$t('at 0:00') }}</h5>
                                        <h1>{{ current_weather.temperature ? current_weather.temperature:'0' }} °C</h1>
                                    </div>
                                    <img :src="current_weather.icon ? current_weather.icon:''" alt="">
                                </div>
                                <div class="background-image" v-else>
                                    <div class="contents">
                                        <h5>{{ marine_weather.city_name ? marine_weather.city_name: $t('location-name')}} {{marine_weather.country_name }} {{ marine_weather.local_time ? marine_weather.local_time:$t('at 0:00') }}</h5>
                                        <h1>{{ marine_weather.temperature ? marine_weather.temperature:'0' }} °C</h1>
                                    </div>
                                    <img :src="marine_weather.icon ? marine_weather.icon:''" alt="">
                                </div>
                                <div v-if="isLoading2" class="card-body text-center">
                                    <i class="fa fa-spinner fa-spin fa-3x"></i>
                                </div>
                                <div v-else>
                                    <div class="mt-4">
                                        <h4>{{ $t('global-weather') }}</h4>
                                        <div v-if="current_weather.length !== 0">
                                            <b-card class="weather-table-card">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <table class="table">
                                                            <tr>
                                                                <td width="70%"><i class="fas fa-sun mr-2"></i><b><span>{{ $t('state')}}</span></b></td>
                                                                <td width="30%"><span>{{ current_weather.state ? current_weather.state: '--' }}</span></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <table class="table">
                                                            <tr>
                                                                <td width="70%"><i class="fas fa-thermometer-half mr-2"></i><b><span>{{ $t('temperature')}}</span></b></td>
                                                                <td width="30%"><span>{{ current_weather.temperature ? current_weather.temperature: '0' }} °C</span></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <table class="table">
                                                            <tr>
                                                                <td width="70%"><i class="fas fa-tint mr-2"></i><b><span>{{ $t('humidity')}}</span></b></td>
                                                                <td width="30%"><span>{{ current_weather.humidity ? current_weather.humidity: '0' }} %</span></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <table class="table">
                                                            <tr>
                                                                <td width="70%"><i class="fas fa-thermometer-half mr-2"></i><b><span>{{ $t('feels-like')}}</span></b></td>
                                                                <td width="30%"><span>{{ current_weather.feels_like ? current_weather.feels_like: '0' }} °C</span></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <table class="table">
                                                            <tr>
                                                                <td width="70%"><i class="fas fa-tachometer-alt mr-2"></i><b><span>{{ $t('pressure')}}</span></b></td>
                                                                <td width="30%"><span>{{ current_weather.pressure ? current_weather.pressure: '0' }} in</span></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <table class="table">
                                                            <tr>
                                                                <td width="70%"><i class="fas fa-umbrella mr-2"></i><b><span>{{ $t('precipitation')}} </span></b></td>
                                                                <td width="30%"><span>{{ current_weather.precipitation ? current_weather.precipitation: '0' }} mm</span></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <table class="table">
                                                            <tr>
                                                                <td width="70%"><i class="fas fa-eye mr-2"></i><b><span>{{ $t('visibility')}}</span></b></td>
                                                                <td width="30%"><span>{{ current_weather.visibility ? current_weather.visibility: '0' }} mi</span></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <table class="table">
                                                            <tr>
                                                                <td width="70%"><b><i class="fas fa-location-arrow mr-2"></i><span>{{ $t('Wind Direction')}}</span></b></td>
                                                                <td width="30%"><span>{{ current_weather.wind_direction ? current_weather.wind_direction: '0' }} °</span></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <table class="table">
                                                            <tr>
                                                                <td width="70%"><i class="fas fa-cloud-sun mr-2"></i><b><span>{{ $t('Cloud Cover')}}</span></b></td>
                                                                <td width="30%"><span>{{ current_weather.cloud_cover ?current_weather.cloud_cover: '0' }} %</span></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <table class="table">
                                                            <tr>
                                                                <td width="70%"><i class="fas fa-wind mr-2"></i><b><span>{{ $t('wind-speed')}}</span></b></td>
                                                                <td width="30%"><span>{{ current_weather.wind_speed ? current_weather.wind_speed: '0' }} mph</span></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                            </b-card>
                                        </div>
                                        <div v-else>
                                            <b-card style="text-align: center;">
                                                <p class="mb-0">{{  $t('no-data-found-for-given-latitude-and-longitude') }}</p>
                                            </b-card>
                                        </div>
                                    </div>
    
                                    <div class="mt-4">
                                        <h4>{{ $t('marine-weather') }}</h4>
                                        <div v-if="marine_weather.length !== 0">
                                            <b-card class="weather-table-card">
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <table class="table">
                                                            <tr>
                                                                <td width="70%"><i class="fas fa-thermometer-half mr-2"></i> <b><span>{{ $t('water-temperature')}}</span></b></td>
                                                                <td width="30%"><span>{{ marine_weather.water_temperature ? marine_weather.water_temperature: '0' }} °C</span></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <table class="table">
                                                            <tr>
                                                                <td width="70%"><i class="fas fa-clock mr-2"></i><b><span>{{ $t('swell-period')}}</span></b></td>
                                                                <td width="30%"><span>{{ marine_weather.swell_period ? marine_weather.swell_period: '0' }} sec</span></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <table class="table">
                                                            <tr>
                                                                <td width="70%"><i class="fas fa-wave-square mr-2"></i><b><span>{{ $t('significant-wave-height')}}</span></b></td>
                                                                <td width="30%"><span>{{ marine_weather.significant_wave_height ? marine_weather.significant_wave_height: '0' }} m</span></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <table class="table">
                                                            <tr>
                                                                <td width="70%"><i class="fas fa-water mr-2"></i><b><span>{{ $t('swell-wave-height')}}</span></b></td>
                                                                <td width="30%"><span>{{ marine_weather.swell_wave_height ? marine_weather.swell_wave_height: '0' }} m</span></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                </div>
                                                <div class="row">
                                                    <div class="col-md-6">
                                                        <table class="table">
                                                            <tr>
                                                                <td width="70%"><i class="fas fa-compass mr-2"></i><b><span>{{ $t('Swell Direction')}}</span></b></td>
                                                                <td width="30%"><span>{{ marine_weather.swell_direction ? marine_weather.swell_direction: '0' }} °</span></td>
                                                            </tr>
                                                        </table>
                                                    </div>
                                                    <div class="col-md-6"></div>
                                                </div>
                                            </b-card>
                                        </div>
                                        <div v-else>
                                            <b-card style="text-align: center;">
                                                <p class="mb-0">{{  $t('no-data-found-for-given-latitude-and-longitude') }}</p>
                                            </b-card>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-6 grid-margin">
                <div class="row ml-1 mb-2">
                    <button class="btn btn-primary" v-on:click="resetForm" variant="primary">
                                {{ $t('add-weather-location') }}
                            </button>
                </div>
                <div class="card">
                    <div class="card-header">
                        <h4 class="card-title">{{ $t('weather-locations') }}</h4>
                    </div>
                    <div class="card-body new-card-body">
                        <vue-good-table mode="remote" @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter" @on-per-page-change="onPerPageChange" :totalRows="totalRecords" :isLoading.sync="isLoading" @on-search="searchFn" :search-options="{enabled: true,searchFn: searchFn}"
                            :pagination-options="{
                                     enabled: true,
                                     dropdownAllowAll: false,
                                     perPageDropdown: [10, 20, 50, 100, 200],
                                 }" :rows="rows" :columns="columns" :line-numbers="true">
                            <template slot="table-row" slot-scope="props">
                                     <span
                                         v-if="props.column.field === 'action'"
                                         class="text-nowrap"
                                     >
                                     <b-button size="sm" @click="editWeather(props.row.id)"
                                                    class="mr-1 btn-info text-white">
                                        {{ $t('edit-btn') }}
                                    </b-button>
                                     <b-button size="sm" @click="getWeatherDetails(props.row.id)" class="mr-1 btn-info text-white" :data-id="props.row.id">
                                         {{ $t('search') }}
                                     </b-button>
                                    <b-button size="sm" @click="deleteWeatherLocation(props.row.id)"
                                            class="mr-1 btn-danger text-white">
                                    {{ $t('delete-btn') }}
                                    </b-button>

                                     </span>
</template>
                         </vue-good-table>
                     </div>
                 </div>
             </div>
         </div>
        <b-modal id="fixmodalmd" ref="vuemodal2" hide-footer :title="title">
            <div>
                <form class="forms-sample" @submit.stop.prevent="onSubmit">
                    <div class="row">
                        <div class="col-md-12">
                            <b-form-group :label="$t('name*')" label-for="name">
                                <b-form-input type="text" id="name" name="name" v-model="$v.form.name.$model" :placeholder="$t('name-placeholder')" :state="$v.form.name.$dirty ? !$v.form.name.$error : null" aria-describedby="input-1-live-feedback">
                                </b-form-input>
                                <b-form-invalid-feedback id="input-1-live-feedback">{{ $t("field-required") }}</b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                        <!-- <div class="col-md-6">
                                <b-form-group :label="$t('TimeZone*')" label-for="TimeZone*">
                                    <b-form-select class="custom-dropdown" v-model="form.time_zone" :options="timezones" :state="$v.form.time_zone.$dirty ? !$v.form.time_zone.$error : null" aria-describedby="input-1-live-feedback"></b-form-select>
                                    <b-form-invalid-feedback id="input-1-live-feedback">{{ $t("field-required") }}</b-form-invalid-feedback>
                                </b-form-group>
                        </div> -->
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <b-form-group :label="$t('latitude*')" label-for="latitude">
                                <b-form-input type="text" id="latitude" autocomplete="new-password" :placeholder="$t('latitude')"  v-model="$v.form.latitude.$model" :state="$v.form.latitude.$dirty ? !$v.form.latitude.$error : null" aria-describedby="input-1-live-feedback"></b-form-input>
                                <b-form-invalid-feedback v-if="!$v.form.latitude.between" id="input-2-live-feedback">
                                    {{ $t("Value must be between -90 and 90") }}
                                </b-form-invalid-feedback>
                                <b-form-invalid-feedback v-if="!$v.form.latitude.required"
                                    id="input-1-live-feedback">{{ $t("field-required") }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                        <div class="col-md-6">
                            <b-form-group :label="$t('longitude*')" label-for="longitude">
                                <b-form-input type="text" id="longitude" autocomplete="new-password" :placeholder="$t('longitude')"  v-model="$v.form.longitude.$model" :state="$v.form.longitude.$dirty ? !$v.form.longitude.$error : null" aria-describedby="input-1-live-feedback"></b-form-input>
                                <b-form-invalid-feedback v-if="!$v.form.longitude.between" id="input-2-live-feedback">
                                    {{ $t("Value must be between -180 and 180") }}
                                </b-form-invalid-feedback>
                                <b-form-invalid-feedback v-if="!$v.form.longitude.required"
                                    id="input-1-live-feedback">{{ $t("field-required") }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </div>
                    </div>
                    <div class="row text-right">
                        <div class="col-md-12">
                            <!-- <b-button type="button" variant="primary" class="btn btn-primary d-flex" @click="closePopup">{{ $t('close-btn') }}</b-button> -->
                            <b-button type="submit" variant="primary" class="mr-2">
                                <span>{{ $t('submit-btn') }}</span>
                            </b-button>
                        </div>
                    </div>
                </form>
            </div>
        </b-modal>
     </section>
 </template>

<script>
    import Vue from "vue";
    import API from '@/api'
    import {
        validationMixin
    } from "vuelidate";
    import {
        required,
        minLength,
        email,
        requiredIf,
        sameAs,
        between
    } from "vuelidate/lib/validators";
    import Snotify, {
        SnotifyPosition
    } from 'vue-snotify'
    // import timeZonesData from '@/assets/files/timezones.json';
    import i18n from '@/i18n';
    import moment from 'moment';
    const options = {
        toast: {
            position: SnotifyPosition.rightTop,
        }
    }
    Vue.use(Snotify, options);
    export default {
        mixins: [validationMixin],
        data() {
            return {
                //  current_weather: {
                current_weather: {
                    timeZone: '',
                    local_time: '',
                    city_name: '',
                    country_name: '',
                    icon: '',
                    state: '',
                    temperature: 0,
                    feels_like: '',
                    cloud_cover: '',
                    wind_direction: 0,
                    wind_speed: 0,
                    visibility: '',
                    precipitation: 0,
                    relative_humidity: '',
                    pressure: 0,
                },
                marine_weather: {
                    local_time: '',
                    city_name: '',
                    country_name: '',
                    icon: '',
                    state: '',
                    temperature: 0,
                    feels_like: '',
                    cloud_cover: '',
                    wind_direction: 0,
                    wind_speed: 0,
                    visibility: '',
                    precipitation: 0,
                    relative_humidity: '',
                    pressure: 0,
                    significant_wave_height: '',
                    swell_wave_height: '',
                    swell_direction: '',
                    swell_period: '',
                    water_temperature: ''
                },
                //  },
                // timezones: timeZonesData,
                form: {
                    latitude: '',
                    longitude: '',
                    // time_zone: '',
                    name: '',
                    client_id: JSON.parse(localStorage.getItem('client_id')),
                },
                title: i18n.t('add-weather-location'),
                serverParams: {
                    client_id: JSON.parse(localStorage.getItem('client_id')),
                    columnFilters: {},
                    sort: [{
                        field: 'id',
                        type: 'desc'
                    }],
    
                    page: 1,
                    perPage: 10
                },
                columns: [{
                        label: 'Name',
                        field: 'name',
                        filterable: true
                    },
                    {
                        label: 'Created At',
                        field: 'created_at',
                        sortable: true,
                        formatFn: this.formatDate
                    },
                    {
                        label: 'Updated At',
                        field: 'updated_at',
                        sortable: true,
                        formatFn: this.formatDate
                    },
                    {
                        label: 'Action',
                        field: "action",
                        sortable: false,
                    },
                ],
                isLoading: false,
                isLoading2: false,
                rows: [],
                totalRecords: 0,
                weatherLocations: [],
            }
        },
        // beforeCreated() {
        //     this.timezones = this.timeZonesData
        // },
        mounted() {
            // console.log('timezones :', this.timezones);
            // const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
            // this.form.time_zone = zone;
            // console.log('zone :', zone);
            // this.$getLocation(options).then(coordinates => {
            //     this.form.latitude = coordinates.lat;
            //     this.form.longitude = coordinates.lng;
            // });
            this.loadItems();
    
        },
        validations: {
            form: {
                id: {},
                name: {
                    required
                },
                // time_zone: {
                //     required
                // },
                latitude: {
                    required,
                    between(value) {
                        return between(-90, 90)(value)
                    }
                },
                longitude: {
                    required,
                    between(value) {
                        return between(-180, 180)(value)
                    }
                },
            },
        },
        methods: {
            getWeatherDetails(id) {
                let data1 = {
                    client_id: JSON.parse(localStorage.getItem('client_id')),
                    id: id,
                }
                this.isLoading2 = true;
                API.getWeatherDetails(
                    data1,
                    data => {
                        if (data.status === 200) {
                            this.current_weather = data.current_weather;
                            this.marine_weather = data.marine_weather;
                            this.$snotify.success(data.message);
                            this.isLoading2 = false;
                        } else {
                            this.$snotify.error(data.message);
                            this.isLoading2 = false;
                        }
                    }, err => {
                        this.isLoading2 = false;
                    });
            },
            onSubmit() {
                this.$v.form.$touch();
                if (this.$v.form.$anyError) {
                    return;
                }
                if (this.form.name != '') {
                    const data = {
                        name: this.form.name,
                        latitude: this.form.latitude,
                        longitude: this.form.longitude,
                        // time_zone: this.form.time_zone,
                        client_id: JSON.parse(localStorage.getItem('client_id'))
                    }
                    this.isDisabled = true;
                    API.getWeatherLocations(
                        this.form,
                        data => {
                            this.$refs["vuemodal2"].$refs['close-button'].click();
                            if (data.status === 200) {
                                this.$snotify.success(data.message);
                            } else {
                                this.$snotify.error(data.message);
                            }
                            this.loadItems();
                            this.isDisabled = false;
                            this.form.name = '';
                            this.form.id = '';
                            this.form.longitude = '';
                            this.form.latitude = '';
                            // this.form.time_zone = '';
                            this.$v.form.$reset();
                        },
                        err => {
                            this.isDisabled = false;
                            this.$snotify.error(err, {
                                timeout: 2000,
                                showProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                            });
    
                        }
                    )
                } else {
                    this.$snotify.warning('Please fill required fields', {
                        timeout: 2000,
                        showProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: true,
                    });
                    this.isDisabled = false;
                }
            },
            resetForm() {
                this.title = i18n.t('add-weather-location');
                this.form.name = '';
                this.form.longitude = '';
                this.form.latitude = '';
                // this.form.time_zone = '';
                this.form.id = '';
                this.$v.form.$reset();
                this.$root.$emit("bv::show::modal", "fixmodalmd");
            },
            loadItems() {
                this.isLoading = true;
                API.getAllWeatherLocations(this.serverParams,
                    data => {
                        this.isLoading = false;
                        this.totalRecords = data.totalRecords;
                        this.rows = data.data.data;
                        this.rows.forEach(q => {
                            const data = {
                                id: q.id,
                            };
                            this.weatherLocations.push(data);
                        });
                    },
                    err => {}
                )
            },
            formatDate(value) {
                if (value) {
                    return moment(String(value)).format('YYYY-MM-DD')
                }
            },
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({
                    page: params.currentPage
                });
                this.loadItems();
            },
            searchFn(params) {
                this.updateParams({
                    searchTerm: params
                });
                this.loadItems();
                this.isLoading = false;
            },
            formatStatus(status) {
                if (status === 1) {
                    return true;
                } else {
                    return false;
                }
            },
            onPerPageChange(params) {
                this.updateParams({
                    perPage: params.currentPerPage
                });
                this.loadItems();
            },
    
            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params[0].type,
                        field: params[0].field,
                    }],
                });
                this.loadItems();
            },
    
            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },
            editWeather(e) {
                this.$v.form.$reset();
                this.title = i18n.t('edit-weather-location');
                this.$root.$emit("bv::show::modal", "fixmodalmd");
                API.getEditWeatherLocation(
                    e, data => {
                        this.form.name = data.name;
                        this.form.id = data.id;
                        this.form.latitude = data.latitude;
                        this.form.longitude = data.longitude;
                        // this.form.time_zone = data.time_zone;
                    },
                    err => {}
                )
            },
            deleteWeatherLocation(e) {
                this.$swal({
                    title: 'Are you sure?',
                    text: "You won't be able to revert this!",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        API.deleteWeatherLocation(
                            e,
                            data => {
                                this.loadItems();
                                this.$snotify.success('Record has been deleted.');
                            },
                            err => {})
                    }
                })
            },
        }
    }
</script>
 
<style lang="scss" scoped>
    .background-image {
        background-image: url(data:image/jpeg;base64,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);
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        display: flex;
        justify-content: space-between;
        align-items: center;
        height: 200px;
    }
    
    .contents {
        color: white;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        text-align: left;
        font-size: 24px;
    }
    
    .contents h5 {
        margin-bottom: 20px;
        margin-left: 12px;
        font-weight: 400;
    }
    
    .contents h1 {
        font-size: 72px;
        font-weight: 700;
        margin-left: 12px;
        margin-bottom: 60px;
    }
    
    .background-image img {
        max-width: 100%;
        max-height: 70px;
        margin-right: 24px;
        color: white;
    }
    
    .new-table-responsive tr td span {
        white-space: pre-wrap;
        line-height: 1.2;
    }
    
    .new-table-responsive tr td span {
        white-space: pre-wrap;
        line-height: 1.2;
    }
    
    .custom-dropdown {
        height: 45px;
    }
    
    .custom-width {
        width: 150px;
    }
    
    .margin-left {
        margin-left: 700px;
        width: 25%;
    }

    .weather-table-card.card .card-body {
        padding: 0 !important;
    }

    @media (max-width: 1780px) {
        .stretch-card.weather-table .weather-table-card .col-md-6 {
            flex: 0 0 100%;
            max-width: 100%;
        }
    }

    @media (max-width: 1199.9px) {
        .stretch-card.weather-table .weather-table-card .col-md-6 {
            flex: 0 0 50%;
            max-width: 50%;
        }
    }

    @media (max-width: 750px) {
        .stretch-card.weather-table .weather-table-card .col-md-6 {
            flex: 0 0 100%;
            max-width: 100%;
        }
    }

    @media (max-width: 440px) {
        .stretch-card.weather-table .weather-table-card .col-md-6 table tr td {
            flex: 0 0 100%;
            max-width: 100%;
            width: 100%;
            display: block;
        }
    }

    @media (max-width: 375px) {
        .card .new-card-body {
            padding: 1.25rem 1.437rem !important;
        }
        .weather-table-card.card .card-body {
            padding: 0 !important;
        }
    }


</style>
  